<template>
    <div class="bg-main">
        <TopBar :isShowToggle="true"></TopBar>
        <div class="container">
            <b-card header="Details" class="text-left custom-card">
                <b-card-text class="custom-text-form">
                    <div class="row">
                        <div class="col-sm-6">
                            <div class="row">
                                <label class="col-12 mb-1"
                                    >Principal Card Holder's NRIC / Passport
                                    Number</label
                                >
                                <div class="col-12 mt-2">
                                    <input
                                        @focusout="focusoutPrincipalCard()"
                                        @input="inputPrincipalCard()"
                                        maxlength="12"
                                        type="text"
                                        class="form-control"
                                        v-model="form.principalCard.value"
                                    />
                                </div>
                                <label
                                    class="col-12 mt-2 custom-detail-text text-muted"
                                >
                                    <div>Principal Card Holder's Name</div>
                                    <div>
                                        Name :
                                        <span
                                            v-html="
                                                form.principalCardName.value
                                            "
                                        ></span>
                                    </div>
                                </label>
                            </div>
                        </div>
                        <div class="col-sm-6">
                            <div class="row">
                                <label class="col-12 mb-1"
                                    >Supplementary Card Holder's NRIC / Passport
                                    Number</label
                                >
                                <div class="col-12 mt-2">
                                    <input
                                        @focusout="focusoutSupplementaryCard()"
                                        @input="inputSupplementaryCard()"
                                        maxlength="12"
                                        type="text"
                                        class="form-control"
                                        v-model="form.supplementaryCard.value"
                                    />
                                </div>
                                <label
                                    class="col-12 mt-2 custom-detail-text text-muted"
                                >
                                    <div>
                                        Supplementary Card Holder's Name
                                    </div>
                                    <div>
                                        Name :
                                        <span
                                            v-html="
                                                form.supplementaryCardName.value
                                            "
                                        ></span>
                                    </div>
                                </label>
                            </div>
                        </div>
                    </div>
                    <div class="row section-policy-supplementary">
                        <div class="col-12">
                            <b-form-checkbox
                                size="lg"
                                id="checkbox-1"
                                name="checkbox-1"
                                value="true"
                                unchecked-value="false"
                                v-model="form.acceptCondition.value"
                            >
                                <span
                                    >By ticking this box, I hereby acknowledge
                                    that I have read and understood the Terms
                                    and Conditions of the BHPetrol eCard Loyalty
                                    Programme and Boustead Petroleum Marketing
                                    Sdn. Bhd’s("BHPetrol")
                                    <a
                                        target="_blank"
                                        href=" http://www.bhpetrol.com.my/disclaimer/privacy-policy"
                                        class="custom-text-color"
                                    >
                                        <u
                                            >Personal Data Protection Notice
                                            ("Privacy Notice")</u
                                        ></a
                                    >
                                    and agree to be bound by the Terms and
                                    Conditions and for my personal data to be
                                    processed in the manner as set forth in the
                                    Privacy Notice.</span
                                >
                            </b-form-checkbox>
                        </div>
                    </div>
                    <div class="row mt-3 custom-btn-color">
                        <div class="col-12 text-center">
                            <button
                                @click="clickReset()"
                                class="mr-3 theme-btn"
                            >
                                Reset
                            </button>
                            <button
                                class="mr-3 theme-btn"
                                @click="clickSubmit()"
                            >
                                Submit
                            </button>
                            <button
                                class="mr-3 theme-btn"
                                @click="goto('home')"
                            >
                                Main Page
                            </button>
                        </div>
                    </div>
                </b-card-text>
            </b-card>
        </div>
        <ModalMaster :controller="modalController"></ModalMaster>
        <BottomBar></BottomBar>
    </div>
</template>

<script>
// @ is an alias to /src
import Vue from "vue";
import Util from "@/helper/Utility.js";

// import Account from "@/helper/AccountHelper.js";
import LocaleMixin from "@/mixin/LocaleMixin.js";
import ErrorApiMixin from "@/mixin/ErrorApiMixin.js";

import ModalMaster from "@/components/Modal/Component/ModalMaster.vue";
import ModalFactory from "@/components/Modal/ModalFactory.js";

import BzbsSupplementary from "@/module/Supplementary/service/BzbsSupplementary.js";
import { SupplementaryModelBuilder } from "@/module/Supplementary/model/SupplementaryModel.js";

// load new component
import TopBar from "@/components/Layout/TopBar/TopBar.vue";
import BottomBar from "@/components/Layout/BottomBar/BottomBar.vue";

export default {
    name: "home",
    components: {
        ModalMaster,
        TopBar,
        BottomBar
    },
    mixins: [LocaleMixin, ErrorApiMixin],
    beforeRouteLeave(to, from, next) {
        // validate enter some text at input
        let checkInput = this.checkInput();
        if (checkInput) {
            this.confirmModal
                .clearText()
                .setMsg(
                    "You have not completed the process. Are you sure you want to leave page?"
                )
                .setBtnOk("Back")
                .setBtnCancel("Leave")
                .setTag("test-confirm")
                .show();
            this.confirmModal.onClickCancel(() => next());
        } else next();
    },
    data: function() {
        return {
            isFirstSaveForm: true,
            valid: false,
            defaultText: "",
            form: {
                principalCard: { value: null, errMsg: null },
                principalCardName: { value: null, errMsg: null },
                supplementaryCard: { value: null, errMsg: null },
                supplementaryCardName: { value: null, errMsg: null },
                acceptCondition: { value: null, errMsg: null }
            },
            // all new modal
            modalController: null,
            alertModal: null,
            loadingModal: null,
            confirmModal: null
        };
    },
    created: function() {
        // initial value
        this.form.principalCardName.value = this.defaultText;
        this.form.supplementaryCardName.value = this.defaultText;
        // Account.loginStatus().then(status => {
        //     this.isLogin = status;
        //     if (status) {
        //         this.profile = Account.getCacheProfile();
        //     }
        // });
        // Vue.ga.screenName(this, "Home");
        // Vue.ga.event(this, "new cat", "view page", "home label");
        // modal setup
        var modalFactory = new ModalFactory();
        this.modalController = modalFactory.getModalController();
        this.alertModal = modalFactory.getAlertModal();
        this.confirmModal = modalFactory.getConfirmModal();
        this.loadingModal = modalFactory.getLoadingModal();
    },
    methods: {
        checkInput: function() {
            let isInput = false;
            let form = this.form;
            try {
                if (form.principalCard.value) throw false;
                if (form.supplementaryCard.value) throw false;
                if (form.acceptCondition.value) throw false;
            } catch (ex) {
                isInput = true;
            }
            return isInput;
        },
        goto: function() {
            this.$router.push("/");
        },
        clickReset: function() {
            this.form = {
                principalCard: { value: null, errMsg: null },
                principalCardName: {
                    value: this.defaultText,
                    errMsg: null
                },
                supplementaryCard: { value: null, errMsg: null },
                supplementaryCardName: {
                    value: this.defaultText,
                    errMsg: null
                },
                acceptCondition: { value: null, errMsg: null }
            };
        },
        clickSubmit: async function() {
            this.isFirstSaveForm = false;
            this.validateForm();
            if (this.valid) {
                let form = this.form;
                let modelBuilder = new SupplementaryModelBuilder();
                modelBuilder
                    .setMainPersonalId(form.principalCard.value)
                    .setChildPersonalId(form.supplementaryCard.value);
                let params = modelBuilder.create().getParams();
                this.loadingModal.show();
                try {
                    let res = await BzbsSupplementary.linkCard(params);
                    if (res) {
                        this.clickReset();
                        this.alertModal
                            .clearText()
                            .setTitle("We have received your request.")
                            .setMsg(
                                "SMS notification will be sent upon your request processed successfully."
                            )
                            .setBtnOk("Main Page")
                            .setTag("alert-1")
                            .show();
                        this.alertModal.onClickOk(() => {
                            this.$router.push("/");
                        });
                    } else {
                        throw res;
                    }
                } catch (ex) {
                    this.errorHandle(ex);
                }

                this.loadingModal.hide();
            }
        },
        validateForm: function() {
            this.valid = false;
            if (this.isFirstSaveForm) return false;
            //#region validate card no..
            this.form.principalCard.errMsg = null;
            if (Util.isEmptyStr(this.form.principalCard.value))
                this.form.principalCard.errMsg =
                    "Please enter Principal Card Holder's NRIC / Passport Number";
            else {
                // check case if only number is NRIC ID otherwise passportId
                let isPassportId = isNaN(this.form.principalCard.value);
                if (isPassportId) {
                    if (
                        this.form.principalCard.value.length < 8 ||
                        this.form.principalCard.value.length > 9
                    )
                        this.form.principalCard.errMsg =
                            "Invalid Passport number. Please re-enter a correct Passport number.";
                } else {
                    if (this.form.principalCard.value.length != 12)
                        this.form.principalCard.errMsg =
                            "Invalid NRIC number. Please re-enter a correct NRIC number.";
                }
            }

            //#endregion

            //#region validate card no..
            this.form.supplementaryCard.errMsg = null;
            if (Util.isEmptyStr(this.form.supplementaryCard.value))
                this.form.supplementaryCard.errMsg =
                    "Please enter Supplementary Card Holder's NRIC / Passport Number";
            else {
                // check case if only number is NRIC ID otherwise passportId
                let isPassportId = isNaN(this.form.supplementaryCard.value);
                if (isPassportId) {
                    if (
                        this.form.supplementaryCard.value.length < 8 ||
                        this.form.supplementaryCard.value.length > 9
                    )
                        this.form.supplementaryCard.errMsg =
                            "Invalid Passport number. Please re-enter a correct Passport number.";
                } else {
                    if (this.form.supplementaryCard.value.length != 12)
                        this.form.supplementaryCard.errMsg =
                            "Invalid NRIC number. Please re-enter a correct NRIC number.";
                }
            }
            //#endregion

            //#region validate acceppt condition
            this.form.acceptCondition.errMsg = null;
            if (this.form.acceptCondition.value != "true") {
                this.form.acceptCondition.errMsg =
                    "Please accept Terms and Conditions";
            }
            //#endregion
            let error = [];
            Object.keys(this.form).forEach(v => {
                let err = this.form[v].errMsg;
                if (err) error.push(err);
            });
            if (error.length > 0) {
                this.alertModal
                    .clearText()
                    .setMsg(`Error<br/>${error[0]}`)
                    .setBtnOk("Main page")
                    .setIsShowSmallClose(true)
                    .setTag("error-info")
                    .show();
                this.alertModal.onClickOk(() => {
                    this.$router.push("/");
                });
            }
            this.valid = error == 0;
        },
        focusoutPrincipalCard: async function() {
            if (!this.form.principalCard.value) return false;
            this.loadingModal.show();
            try {
                this.form.principalCardName.value = null;
                let id = this.form.principalCard.value;
                let res = await BzbsSupplementary.getProfileById(id);
                if (res) {
                    let fullName = res.data.fullName;
                    this.form.principalCardName.value = this.hideSomeNameByRule(
                        fullName
                    );
                }
            } catch (ex) {
                //console.log(ex)
            }
            this.loadingModal.hide();
        },
        inputPrincipalCard: function() {
            this.form.principalCard.value = this.replaceCharacter(
                this.form.principalCard.value
            );
        },
        focusoutSupplementaryCard: async function() {
            if (!this.form.supplementaryCard.value) return false;
            this.loadingModal.show();
            try {
                this.form.supplementaryCardName.value = null;
                let id = this.form.supplementaryCard.value;
                let res = await BzbsSupplementary.getProfileById(id);
                if (res) {
                    let fullName = res.data.fullName;
                    this.form.supplementaryCardName.value = this.hideSomeNameByRule(
                        fullName
                    );
                }
            } catch (ex) {
                // console.log(ex)
            }
            this.loadingModal.hide();
        },
        inputSupplementaryCard: function() {
            this.form.supplementaryCard.value = this.replaceCharacter(
                this.form.supplementaryCard.value
            );
        },
        errorHandle: function(ex) {
            let msg = ex.response.data.error;
            let header = `Your registration is unsuccessful.`;
            let body = `<div>Error ${msg.code}</div>`;
            // let errMsg = msg.message.split("|").pop();
            // let tmpErrMsg = "";
            // let checkPrimarySide = errMsg
            //     .split(" ")
            //     .find(o => o == this.form.principalCard.value);
            // // check type of card
            // if (checkPrimarySide) {
            //     tmpErrMsg = "Principal NRIC / Passport Number";
            // } else {
            //     tmpErrMsg = "Supplementary NRIC / Passport Number ";
            // }
            // // case id dose not exist
            // let case1 = "IDNo does not exists";
            // let case2 = "Primary IDNo does not have PrimaryCard";
            // if (errMsg.indexOf(case1) > -1) {
            //     tmpErrMsg += " not found in our system";
            // } else if (errMsg.indexOf(case2) > -1) {
            //     tmpErrMsg += " Primary ID No does not have Primary Card".toLowerCase();
            // }

            // body += `<div>${tmpErrMsg}</div>`;
            body += `<div>Please contact BHPetrol Customer Service Centre at 03- 7719 9499 for further assistance.</div>`;
            this.alertModal
                .clearText()
                .setTitle(header)
                .setMsg(body)
                .setBtnOk("Main Page")
                .setIsShowSmallClose(true)
                .setTag("alert-1")
                .show();
            this.alertModal.onClickOk(() => {
                this.$router.push("/");
            });
        },
        replaceCharacter: function(txt) {
            txt = txt.replace(Vue.RegExp.emoji, "");
            txt = txt.replace(Vue.RegExp.notAlphabet, "");
            return txt;
        },
        hideSomeNameByRule: function(txt) {
            let firstText = txt.substr(0, 3);
            let lastText = txt.substr(txt.length - 2, txt.length);
            let hideTxt = txt
                .substring(3, txt.length - 2)
                .replace(/[\S]/g, "X");
            return `${firstText}${hideTxt}${lastText}`;
        }
    }
};
</script>
<style lang="scss" scoped>
@import "../../Registration/page/Registration.scss";
@import "Supplementary.scss";

.div-flex {
    display: flex;
}
</style>
